<div class="container">
  <div class="header">
    <div>
      <i class="material-icons icon">library_books</i>
    </div>
    <div class="logs-header-container">
      <h4 class="title">Logs</h4>
    </div>
  </div>
  <div class="logs-page-body">
    <div class="logs-container" *ngIf="grafanaEnabled">
      <iframe class="iframeContent" height="800" frameBorder="0" [src]="srcSafeURL"></iframe>
    </div>
    <div class="logsErroMsg" *ngIf="!grafanaEnabled">
      <div class="img"><i class="mdi mdi-cloud-off-outline"></i></div>
      <div>{{ grafanaErroMsg }}</div>
    </div>
  </div>
</div>
